
const uniqueDeviceIdKey = 'uniqueDeviceId'

export const createAndReturnUniqueDeviceId = (): string => {
  const existingId = localStorage.getItem(uniqueDeviceIdKey)
  if (existingId) return existingId

  let newId = ''
  try {
    newId = crypto.randomUUID()
  } catch {
    // Fallback for browsers that do not support crypto.randomUUID()
    // Mostly on localhost during development
    newId = 'localhost_' + Math.random().toString(36).substring(2) + Date.now().toString(36)
  }

  localStorage.setItem(uniqueDeviceIdKey, newId)
  return newId
}
